import QuestionCatalogSelector from '@core/components/legislation/QuestionCatalogSelector.vue'

export default QuestionCatalogSelector
